export const name = 're-core-page-shop-buy-gift-card-extended'
export const component = 're-buy-giftcard-extended'

import {factory} from '../../../../../lib/page'

const props = {
  terms: {},
  item: {},
  token: {}
}

export default factory(name, {props, component})
